import React from 'react'
import logo from '../img/RK Designs.png'
import { AnimationOnScroll } from 'react-animation-on-scroll'

function About() {
    return (
        <AnimationOnScroll animateIn='slipeLeft'>
            <section id="section2">
                <div className="about">
                    <h2>ABOUT US</h2>
                </div>
                <div className="About">
                    <div className="mypic">
                        <img className="rajat" src={logo} alt="RK Designs" />
                    </div>
                    <div className="written">
                        <p>
                            Welcome to <span>RK Designs</span>, where we specialize in providing exceptional design services to our clients. We offer a range of services including Planning drawings, Front Elevation Designs, Modular Kitchen Designs, Landscape drawings, and Electrical drawings. We are dedicated to delivering personalized and high-quality services to each of our clients, taking the time to understand their needs and preferences in order to create the perfect design for their space. Whether you're looking to renovate your home or design a new commercial space, we're here to help you achieve your goals. Contact us today to learn more about our services and to schedule a consultation.
                        </p>
                    </div>
                </div>
            </section>
        </AnimationOnScroll>
    )
}

export default About
